import React from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import BottomBar from './BottomBar';

const Layout = ({ children }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#0f172a' }}>
      
      {/* TopBar na vrhu - cela sirina ekrana */}
      <TopBar />

      <div style={{ display: 'flex', flex: 1, position: 'relative' }}>
        {/* Sidebar levo - smešten između Top i Bottom bara */}
        <Sidebar />

        {/* Glavni sadržaj desno */}
        <main style={{ 
          flex: 1, 
          marginLeft: '240px', 
          padding: '20px',
          color: 'white',
          marginTop: '65px',   // Razmak zbog TopBara
          marginBottom: '40px' // Razmak zbog BottomBara
        }}>
          {children}
        </main>
      </div>

      {/* BottomBar na dnu - cela sirina ekrana */}
      <BottomBar />
      
    </div>
  );
};

export default Layout;